import { createFileRoute } from '@tanstack/react-router'
import { eduInternSearchSchema } from '@/features/edu-interns/filter-edu-interns/model/eduInternSearch'
import { EduInternsPage } from '@/pages/internships/ui/EduInternsPage'

export const Route = createFileRoute('/edu-interns')({
  validateSearch: eduInternSearchSchema,
  component: EduInternsPage,
})
